  import { createTheme } from '@mui/material/styles';
  import '@fontsource/ibm-plex-sans-thai/400.css';
  import '@fontsource/ibm-plex-sans-thai/500.css';
  import '@fontsource/ibm-plex-sans-thai/700.css';

  export const theme = createTheme({
    typography: {
      fontFamily: '"IBM Plex Sans Thai", sans-serif',
    },
    palette: {
      primary: {
        main: '#FEDC00',   // สีเหลือง Royal Park
        contrastText: '#000', // ตัวหนังสือสีดำ
      },
      secondary: {
        main: '#333333',   // สีรอง (เทาเข้ม)
      },
      background: {
        default: '#FFF9E5', // สีพื้นหลังอ่อน
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            fontWeight: 'bold',
          },
        },
      },
    },
  });
